import React from "react";
import { showLoginPopup } from "../../redux/editorSlice";
import Popup from "../../../../EventOrganiser/Popup";
import { motion } from "framer-motion";
import { useDispatch } from "react-redux";
import RegisterOptions from "./RegisterOptions";

// export default function GeneralRegister({ onStepChange }) {
//   const dispatch = useDispatch();
//   return (
//     <Popup
//       title="Please register your Mobile Number or Gmail to save your work"
//       minHeight="400px"
//       maxWidth="500px"
//       onClose={() => dispatch(showLoginPopup(false))}
//     >
//       <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.3 }}
//         className="popup-step"
//       >
//         <div id="popup-step-anchor">
//           {" "}
//           <RegisterOptions onStepChange={onStepChange} />
//         </div>
//       </motion.div>
//     </Popup>
//   );
// }
export default function GeneralRegister({
  onStepChange,
  onClose,
  onRegistered,
}) {
  return (
    <Popup
      title="Please register your Mobile Number  to explore the feature"
      minHeight="400px"
      maxWidth="500px"
      onClose={onClose} // just close popup, do not proceed
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        className="popup-step"
      >
        <div id="popup-step-anchor">
          <RegisterOptions
            onStepChange={onStepChange}
            onRegistered={onRegistered} // called after successful registration
          />
        </div>
      </motion.div>
    </Popup>
  );
}
